<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'attendees' }">Attendees</el-breadcrumb-item>
            <el-breadcrumb-item>Edit {{ name }}</el-breadcrumb-item>
        </el-breadcrumb>

        <div v-if="loading" class="col-12 mt-5 mb-5" v-loading="true"></div>

        <card v-else class="mt-3">
            <template slot="header">
                <span class="font-weight-bold">{{ name }}</span>
            </template>
            <tabs type="primary" v-model="currentTab" @click="changeTab">
                <tab-pane id="general_information" label="General Information">
                    <div class="d-flex justify-content-end" style="flex-wrap: wrap;">
                        <router-link
                            v-if="registration.parent"
                            :to="{ name: 'attendees', query: { parent: registration.parent._id } }">
                                <el-button class="btn">
                                    <fa icon="users"/> See group
                                </el-button>
                        </router-link>
                        <router-link
                            v-else-if="children.length"
                            :to="{ name: 'attendees', query: { parent: registration._id } }">
                                <el-button class="btn">
                                    <fa icon="users"/> See group
                                </el-button>
                        </router-link>
                        <router-link
                            v-else-if="!children.length && !registration.parent"
                            :to="{ name: 'attendees', query: { parent: registration._id } }">
                                <el-button class="btn">
                                    <fa icon="users"/> See group
                                </el-button>
                        </router-link>
                        <router-link
                            v-if="!registration.parent"
                            :to="{ name: 'registration-edit', params: { eventId: registration.event._id, id: registration._id } }">
                                <el-button class="btn">
                                    View / Edit registration
                                </el-button>
                        </router-link>
                        <router-link
                            v-if="!registration.parent"
                            target="_blank"
                            :to="{path: '/welcome-email/' + registration._id }">
                                <el-button class="btn">
                                    View Status/Confirmation
                                </el-button>
                        </router-link>
                    </div>
                    <el-form label-width="220px" :label-position="$store.state.props.isMobile ? 'top' : 'right'">
                        <el-form-item label="Registration ID">
                            {{ registration._id }}
                        </el-form-item>
                        <el-form-item label="Registration Number">
                            {{ registration.confirmationNumber }}
                        </el-form-item>
                        <el-form-item label="Attendee Type *" v-if="registration.type && registration.type._id">
                            <el-select
                                v-if="editMode"
                                v-model="registration.type"
                                @change="onAttendeeSelect"
                                class="w-100">
                                    <el-option
                                        v-for="t in $store.state.types"
                                        :key="`registration-type-${t._id}`"
                                        :label="t.name"
                                        :value="t"/>
                            </el-select>
                            <span v-else>{{ registration.type.name }}</span>
                        </el-form-item>
                        <div v-if="registration.type && registration.type._id && registration.type.fields && registration.type.fields.length">
                            <el-form-item
                                v-for="(field, index) in registration.fields"
                                v-if="field && field.published && field.showOnRegistrationScreen"
                                :key="`custom-field-${index}`"
                                :label="`${field.title} ${field.required ? '*': ''}`">
                                    <div v-if="field.type === 'calendar'">
                                        <el-date-picker
                                            v-if="editMode"
                                            v-model="field.value"/>
                                        <span>{{ field.value | formatDate }}</span>
                                    </div>
                                    <div v-else-if="field.type === 'media'">
                                        <a
                                            v-if="getMedia && getMedia[field._id]"
                                            :href="getMedia[field._id].url"
                                            :download="getMedia[field._id].url"
                                            @click.prevent="download({ path: getMedia[field._id].path, name: getMedia[field._id].name  })">
                                                {{ getMedia[field._id].name }}
                                        </a>
                                    </div>
                                    <div v-else-if="field.type === 'checkboxes'">
                                        <el-checkbox-group
                                            v-if="editMode"
                                            v-model="field.value">
                                                <el-checkbox
                                                    v-for="(value, index) in field.values.split('\n')"
                                                    :label="value">
                                                        {{ field.labels.split('\n')[index] }}
                                                </el-checkbox>
                                        </el-checkbox-group>
                                        <div v-else>
                                            <div v-if="field.value">
                                            <span
                                                v-for="(value, index) in field.values.split('\n')"
                                                v-if="field.value.includes(value)">
                                                    <span v-if="index !== 0">, </span>
                                                    {{ field.labels.split('\n')[index] }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else-if="field.type === 'list'">
                                        <el-select
                                            v-if="editMode"
                                            v-model="field.value">
                                                <el-option
                                                    v-for="(value, index) in field.values.split('\n')"
                                                    :value="value"
                                                    :label="field.labels.split('\n')[index]"/>
                                        </el-select>
                                        <div v-else>
                                            <span
                                                v-for="(value, index) in field.values.split('\n')"
                                                v-if="value === field.value">
                                                    {{ field.labels.split('\n')[index] }}
                                            </span>
                                        </div>
                                    </div>
                                    <div v-else-if="field.type === 'radio'">
                                        <el-radio
                                            v-if="editMode"
                                            v-for="(value, index) in field.values.split('\n')"
                                            v-model="field.value"
                                            :label="value">
                                                {{ field.labels.split('\n')[index] }}
                                        </el-radio>
                                        <div v-else>
                                            <span
                                                v-for="(value, index) in field.values.split('\n')"
                                                v-if="value === field.value">
                                                    {{ field.labels.split('\n')[index] }}
                                            </span>
                                        </div>
                                    </div>
                                    <div v-else-if="field.type === 'color'">
                                        <el-color-picker
                                            v-if="editMode"
                                            v-model="field.value"/>
                                        <div v-else>
                                            {{ field.value }}
                                            <div :style="{ 'background-color': field.value, width: '32px', height: '32px', display: 'block' }"></div>
                                        </div>
                                    </div>
                                    <div v-else-if="field.type === 'integer'">
                                        <el-input
                                            v-if="editMode"
                                            v-model="field.value"
                                            type="number"/>
                                        <span v-else>{{ field.value }}</span>
                                    </div>
                                    <div v-else-if="field.type === 'text'">
                                        <el-input
                                            v-if="editMode"
                                            v-model="field.value">
                                                <template
                                                    v-if="field.validations.url"
                                                    slot="prepend">https://</template>
                                                <template
                                                    v-if="field.validations.ip"
                                                    slot="prepend">IP</template>
                                        </el-input>
                                        <span v-else>{{ field.value }}</span>
                                    </div>
                                    <div v-else-if="field.type === 'textarea'">
                                        <el-input
                                            v-if="editMode"
                                            v-model="field.value"
                                            type="textarea"/>
                                        <span v-else>{{ field.value }}</span>
                                    </div>
                                    <div v-else-if="field.type === 'editor'">
                                        <quill-editor
                                            v-if="editMode"
                                            v-model="field.value"/>
                                        <div v-else v-html="field.value"></div>
                                    </div>
                            </el-form-item>
                            <el-form-item label="QR Code">
                                <img :src="$store.state.baseUrl + registration.qr" width="128px"/>
                            </el-form-item>
                            <el-form-item label="Registration Date">
                                <span>{{ registration.createdAt | registrationDate }}</span>
                            </el-form-item>
                            <div v-if="!(registration.parent && registration.parent._id)">
                                <el-form-item label="Total">
                                    {{ registration.total }}
                                </el-form-item>
                                <el-form-item label="Due">
                                    {{ registration.total - registration.paid }}
                                </el-form-item>
                            </div>
                            <div v-else>
                                <el-form-item label="">
                                    <router-link :to="{ name: 'attendee', params: { registrationId: registration.parent._id } }">
                                        Check group registrant payment information
                                    </router-link>
                                </el-form-item>
                            </div>
                        </div>
                    </el-form>
                </tab-pane>
                <tab-pane id="activities" label="Activities">
                    <h6 class="mt-3">Activities</h6>
                    <el-table :data="Object.values(activities)">
                        <el-table-column label="Name" prop="name"/>
                        <el-table-column label="Registered" align="center">
                            <template slot-scope="props">
                                <el-checkbox v-if="user.admin || !event.viewRegActEditAdminOnly" v-model="props.row.registered"/>
                                <el-checkbox v-else :value="props.row.registered" :disabled="true" /> 
                            </template>
                        </el-table-column>
                        <el-table-column label="Checked In" align="center">
                            <template slot-scope="props">
                                <fa
                                    v-if="props.row.checkedInAttendees.includes(registration._id)"
                                    :icon="['fas', 'check']"/>
                                <fa
                                    v-else
                                    :icon="['fas', 'times']"/>
                            </template>
                        </el-table-column>
                        <el-table-column label="Actions" v-if="user.admin || !event.viewRegActEditAdminOnly" align="center">
                            <template slot-scope="props">
                                <router-link
                                    v-if="!props.row.checkedInAttendees.includes(registration._id)"
                                    :to="{ name: 'scanner', params: { id: props.row._id, type: 'activity' } }">
                                        <el-button class="btn">
                                            <fa :icon="['fas', 'qrcode']"/>
                                            Checkin
                                        </el-button>
                                </router-link>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="d-flex justify-content-end">
                        <el-button
                            type="primary" v-if="user.admin || (!event.viewRegActEditAdminOnly && event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].viewRegistrationTypes)"
                            class="btn btn-primary"
                            :loading="updating"
                            @click="updateRegistration()">
                                Save
                        </el-button>
                    </div>
                </tab-pane>
                <tab-pane id="payments" label="Payments">
                    <div>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-between space-between-div">
                                <div>
                                    <template v-if="!(registration.parent && registration.parent._id)">
                                        <div>Due <span class="font-weight-bold">{{ registration.event.appCurrency }} {{ parseFloat(registration.total - registration.paid).toFixed(2) }}</span></div>
                                        <div>Paid <span class="font-weight-bold"> {{ registration.event.appCurrency }} {{ parseFloat(registration.paid).toFixed(2) }}</span></div>
                                        <div>Total <span class="font-weight-bold">{{ registration.event.appCurrency }} {{ parseFloat(registration.total).toFixed(2) }}</span></div>
                                        <div><el-checkbox :label="hideSystemGeneratedDiscount" @change="discountHandler">Hide all system generated discounts</el-checkbox> </div>
                                    </template>
                                </div>
                                <div>
                                    <router-link
                                        :to="{ name: 'attendees', query: { parent: registration.parent ? registration.parent._id : registration._id } }">
                                            <el-button class="btn">
                                                <fa icon="users"/> See group
                                            </el-button>
                                    </router-link>

                                    <div v-if="!(registration.parent && registration.parent._id)" style="display: inline;">
                                        <router-link :to="{ name: 'registration-edit', params: { id: registration._id  } }" v-if="user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].checkinRegistrants)"
                                            type="primary"
                                            class="btn">
                                                View/Edit Registration
                                        </router-link>
    
                                        <el-button v-if="user.admin ||getEditPaymentPermission && userIsAllowedToEdit && (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].checkinRegistrants)"
                                            @click="transactionDialog = true"
                                            type="primary"
                                            class="btn btn-primary">
                                                New Transaction
                                        </el-button>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <el-table v-if="!(registration.parent && registration.parent._id)" :data="payments.filter(data=>((data.systemGenerated==1 && !hideSystemGeneratedDiscount) || (data.systemGenerated!=1 && !(data.parentRegistrant && data.type=='charge')   )) )">
                            <el-table-column label="Date">
                                <template slot-scope="props">
                                    {{ props.row.createdAt | paymentDate }}
                                </template>
                            </el-table-column>
                            <el-table-column label="Transaction">
                                <template slot-scope="props">
                                    <span>
                                        {{ props.row.type }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Amount">
                                <template slot-scope="props">
                                    <div class="d-flex">
                                        <el-tag v-if="props.row.type === 'payment'" type="success">{{ props.row.amount }} {{ registration.event.appCurrency }}</el-tag>
                                        <el-tag v-else-if="props.row.type === 'charge'" type="danger">{{ props.row.amount }} {{ registration.event.appCurrency }}</el-tag>
                                        <el-tag v-else type="info">{{ props.row.amount }} {{ registration.event.appCurrency }}</el-tag>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="Description" prop="description"/>                           
                            <el-table-column label="Payment Method">
                                <template slot-scope="props">
                                    <span v-if="props.row.type == 'payment'">
                                        {{ props.row.method }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Registrant">
                                <template slot-scope="props">
                                    <span v-if="props.row.systemGenerated==1">
                                        {{ props.row.registration.keywords.split(', ').slice(0,3).join(' ') }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column label="By">
                                <template slot-scope="props">
                                    <span v-if="props.row.by">
                                        {{ props.row.by.email }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="Actions"
                                :width="300">
                                    <template slot-scope="props" v-if="getEditPaymentPermission && userIsAllowedToEdit && isDeletionAllowed(props.row)">
                                        <el-tooltip content="Remove" placement="top">    
                                            <el-button
                                                @click="deletePayment(props.row)"
                                                class="btn ml-1"
                                                title="Remove">
                                                    <fa :icon="['fas', 'trash']"/>
                                            </el-button>
                                        </el-tooltip>
                                    </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-if="(registration.parent && registration.parent._id)">
                        <router-link :to="{ name: 'attendee', params: { registrationId: registration.parent._id } }">
                            Check group registrant payment information
                        </router-link>
                    </div>
                </tab-pane>
                <tab-pane id="sent_messages" label="Sent Messages">
                    <div class="d-flex justify-content-end">
                        <el-button
                            @click="newMessageDialog = true"
                            type="primary">
                                New Message
                        </el-button>
                    </div>

                    <ul class="list-group mt-3">
                        <li
                            v-for="message in $store.state.messages"
                            :key="`messages-${message._id}`"
                            class="list-group-item">
                                <h6 class="m-0">{{ message.subject }}</h6>
                                <div class="m-0 pt-4 pb-4" v-html="message.content"></div>
                                <p class="m-0">Sent Date: {{ message.createdAt | sentDate }}</p>
                                <p class="m-0">Status: <span class="font-weight-bold" style="text-transform: capitalize">{{ message.status }}</span></p>
                        </li>
                    </ul>
                </tab-pane>
            </tabs>
            <template v-if="editMode" slot="footer">
                <div class="d-flex justify-content-end">
                    <el-button
                        class="btn btn-primary"
                        :loading="saving"
                        @click="submit()">
                            Save
                    </el-button>
                </div>
            </template>
        </card>

        <el-dialog v-if="getEditPaymentPermission && userIsAllowedToEdit" :close-on-click-modal="false" :visible.sync="transactionDialog" title="New Transaction">
            <el-form label-position="top">
                <el-form-item label="Transaction Type">
                    <el-radio-group v-model="payment.type">
                        <el-radio-button label="payment">Payment</el-radio-button>
                        <el-radio-button label="charge">Charge</el-radio-button>
                        <el-radio-button v-if="user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].allowApplyingManualDiscountsForRegistrations)" label="discount">Discount</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Amount">
                    <el-input
                        v-model="payment.amount"
                        type="number"
                        min="0"/>
                </el-form-item>
                <el-form-item label="Description / Check Number">
                    <el-input v-model="payment.description"/>
                </el-form-item>
                <el-form-item label="Payment Method" v-if="showPaymentMethod">
                    <el-radio-group v-model="payment.method">
                        <el-radio-button label="cash">
                            Cash
                        </el-radio-button>
                        <el-radio-button label="check">
                            Check
                        </el-radio-button>
                        <el-radio-button label="paypal">
                            Paypal
                        </el-radio-button>
                        <el-radio-button :label="event.paymentProviderName" v-if="event.enableZelle">
                            {{ event.paymentProviderName }}
                        </el-radio-button>
                        <el-radio-button label="stripe" v-if="event.enableStripe">
                            Stripe
                        </el-radio-button>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <template slot="footer">
                <div class="d-flex justify-content-end">
                    <el-button
                        class="btn btn-primary"
                        type="primary"
                        @click="submitTransaction()"
                        :loading="charging">
                            Submit
                    </el-button>
                </div>
            </template>
        </el-dialog>

        <el-dialog
            title="New Message"
            :visible.sync="newMessageDialog">
                <el-form>
                    <el-form-item label="Subject">
                        <el-input v-model="newMessage.subject"/>
                    </el-form-item>
                    <el-form-item label="Content">
                        <el-input
                            v-model="newMessage.content"
                            type="textarea"/>
                    </el-form-item>
                </el-form>
                <template slot="footer">
                    <div class="d-flex justify-content-end">
                        <el-button
                            type="primary"
                            @click="sendMessage()"
                            :loading="sendingMessage">
                                Send
                        </el-button>
                    </div>
                </template>
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import swal from 'sweetalert2'
import { mapState } from 'vuex'
import download from 'downloadjs'
import http from '../../http'

const emptyMessage = () => {
    return {
        subject: '',
        content: ''
    }
}

export default {
    data () {
        return {
            loading: true,
            registration: {},
            children: [],
            editMode: false,
            saving: false,
            transactionDialog: false,
            charging: false,
            name: '',
            paying: {},
            newMessageDialog: false,
            newMessage: emptyMessage(),
            sendingMessage: false,
            activities: {},
            updating: false,
            hideSystemGeneratedDiscount: false,
            payment: {
                registrationId: this.$route.params.registrationId,
                eventId: this.$route.params.eventId,
                amount: 0,
                description: '',
                type: 'payment',
                method: 'cash'
            },
            uploadedFiles: [],
            currentTab: "general_information",
            showPaymentMethod: true
        }
    },
    computed: {
        ...mapState([
            'payments',
            'baseUrl',
            'user',
            'event'
        ]),
        getMedia(){
            let arr = []
            this.uploadedFiles.forEach(el=>{
                arr[el.fieldId] = {
                    url: this.baseUrl + el.path,
                    name: el.name,
                    path: el.path
                }
            })
            return arr
        },
        getEditPaymentPermission(){
            if(this.user.admin) return true;
            if(this.event && this.event.adminRoles){
                return this.event.adminRoles[this.user._id].editPaymentsForRegistrants;
            }
            return false;
        },
        userIsAllowedToEdit(){
            if(this.user._id && this.user.admin){
                return true
            }
            if(!this.user._id){
                return true
            }
            if(this.registration){
                const { value, date } = this.user.roles[this.$route.params.eventId].preventUserFromEditingRegistrationsCreatedAfterDate;
                if(!value) return true;

                const createdAt = new Date(this.registration.createdAt);
                const userAllowedToEditAfterDate = new Date(date);
                if(createdAt < userAllowedToEditAfterDate){
                    return false
                }
                return true
            }

            return true
        }

    },
    watch: {
        '$route.params.registrationId': 'getData',
        'payment.type': 'updateShowPaymentMethod',
    },
    beforeMount () {
        let tab = this.$route.query.tab;
        
        if(tab && ["general_information", "activities", "payments", "sent_messages"].includes(tab)){
            this.currentTab = tab
        }
        this.getData()
    },
    methods: {
        changeTab(){
            this.$router.replace(`${this.$route.path}?tab=${this.currentTab}`)
        },
        isDeletionAllowed(data){
            if(this.user.admin && !( data.systemGenerated==0 && data.by==undefined && data.type=='charge' )) return true;
            if(data.systemGenerated) return false;
            return ((this.event.adminRoles && this.event.adminRoles[this.user._id] && this.event.adminRoles[this.user._id].checkinRegistrants)) && !( data.systemGenerated==0 && data.by==undefined && data.type=='charge' );
        },
        updateShowPaymentMethod(val){
            if(['discount', 'charge'].includes(val)){
                this.showPaymentMethod = false
                this.payment.method = "manual"
            }else{
                this.showPaymentMethod = true
                if(this.payment.method == "manual") this.payment.method = "cash"
            }
        },
        getData: async function () {
            this.loading = true
            this.payment.registrationId = this.$route.params.registrationId

            try {
                const response = await http.get(`/api/registrations/${this.$route.params.registrationId}?withChildregistrations=true`)
                const response_type = await http.get(`/api/types?filters={"eventId":"${this.$route.params.eventId}"}`) 
                this.registration = response.data.registration
                const res = await this.$store.dispatch('getUploadedFilesForRegistration', this.payment.registrationId)
                this.uploadedFiles = res.data.uploads
                
                
                // console.log('this.registration', this.registration)
                // console.log('response_type', response_type.data.types)
                let currentIndex = null
                response_type.data.types.findIndex((item, index)=>{
                    if(item._id == this.registration.type._id)
                        currentIndex = index
                })
                
                let new_fields = []
                response_type.data.types[currentIndex].fields.map((e, i)=>{
                    if(this.registration.fields[i]==undefined){
                        new_fields.push(e)
                    }
                })
                this.registration.fields = this.registration.fields.concat(new_fields);
                this.children = response.data.childRegistrations

                const firstName = this.registration.fields.find(field => field.fieldMapping === 'firstName')
                const lastName = this.registration.fields.find(field => field.fieldMapping === 'lastName')

                await Promise.all([
                    this.$store.dispatch('getAll', { path: 'types', params: { filters: { eventId: this.$route.params.eventId } } }),
                    this.$store.dispatch('getAll', { path: 'payments', params: { filters: { registrationId: this.$route.params.registrationId } } }),
                    this.$store.dispatch('getAll', { path: 'messages', params: { filters: { registrationId: this.$route.params.registrationId } } }),
                    this.$store.dispatch('getAll', { path: 'activities', params: { filters: { eventId: this.$route.params.eventId } } })
                ])
                
                this.$store.state.activities.forEach(activity => {
                    this.$set(this.activities, activity._id, {
                        ...activity,
                        registered: false
                    })
                })

                // register field based activities
                this.registration.fieldBasedActivities.forEach(activity => {
                    this.$set(this.activities[activity._id], 'registered', true)
                })

                // register registered activities
                this.registration.registeredActivities.forEach(activity => {
                    this.$set(this.activities[activity._id], 'registered', true)
                })
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('erorr getting registration')
            }
            this.loading = false
        },
        onAttendeeSelect: function () {
            this.registration.fields = []
            this.registration.type.fields.forEach(field => {
                let value = ''
                if (field.type === 'checkboxes' ||
                    (field.type === 'list' && field.multiple)) {
                        value = []
                }
                this.registration.fields.push({
                    ...field,
                    value
                })
            })
        },
        submit: async function () {
            if(!this.userIsAllowedToEdit){
                this.$notify({
                    type: "danger",
                    message: "you are not allowed to make this request"
                })
                return
            }

            
            try {
                this.saving = true
                await this.$store.dispatch('update', { path: 'registrations', data: this.registration, id: this.$route.params.registrationId })
                this.$notify('Successfully updated!')
            } catch (e) {
                console.log('error udpating information')
            }
            this.saving = false
        },
        submitTransaction: async function () {
            if(!this.userIsAllowedToEdit){
                this.$notify({
                    type: "danger",
                    message: "you are not allowed to make this request"
                })
                return
            }

            this.charging = true
            try {
                this.payment.creator = this.user
                const response = await this.$store.dispatch('create', { path: 'payments', data: this.payment })
                this.$store.commit('SET', ['payments', [response.data.payment, ...this.$store.state.payments]])

                if (this.payment.type === 'payment') {
                    this.$set(this.registration, 'paid', this.registration.paid + parseInt(this.payment.amount))
                    this.$notify('Payment was successfully created!')
                } else if (this.payment.type === 'discount') {
                    this.$set(this.registration, 'total', this.registration.total - parseInt(this.payment.amount))
                    this.$notify('Discount was successfully created!')
                } else {
                    this.$set(this.registration, 'total', this.registration.total + parseInt(this.payment.amount))
                    this.$notify('Charge was successfully created!')
                }

                this.transactionDialog = false
            } catch (e) {
                console.log(e)
                console.log('error creating charge')
            }
            this.charging = false
        },
        deletePayment: async function (payment) {
            try {
                let { value: confirmed } = await swal({
                    title: `Are you sure you want to delete the payment information?`,
                    buttonsStyling: false,
                    showCancelButton: true,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-default btn-fill'
                })

                if (!confirmed) {
                    return
                }
                
                if (payment.type === 'payment') {
                    this.$set(this.registration, 'paid', this.registration.paid - parseInt(payment.amount))
                } if (payment.type === 'charge') {
                    this.$set(this.registration, 'total', this.registration.total - parseInt(payment.amount))
                } if (payment.type === 'discount') {
                    this.$set(this.registration, 'total', this.registration.total + parseInt(payment.amount))
                }

                this.$store.commit('SET', ['payments', this.payments.filter(p => p._id !== payment._id)])
                await this.$store.dispatch('remove', { path: 'payments', id: payment._id })
            } catch (e) {
                console.log(e)
                console.log('error deleting payment')
            }
        },
        sendMessage: async function () {
            this.sendingMessage = true
            try {
                const response = await this.$store.dispatch('create', {
                    path: 'messages',
                    data: {
                        ...this.newMessage,
                        registrationId: this.$route.params.registrationId,
                        host: this.$store.state.baseUrl
                    }
                })
                this.$store.commit('SET', ['messages', [response.data.message, ...this.$store.state.messages]])
                this.newMessage = emptyMessage()
                this.newMessageDialog = false
            } catch (e) {
                console.log(e)
                console.log('error sending message')
            }
            this.sendingMessage = false
        },
        download: async function (file) {
            try {
                const response = await http.get(this.baseUrl + file.path, {
                    responseType: 'arraybuffer'
                })
                download(response.data, file.name)
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error downloading list')
            }
        },
        updateRegistration: async function () {
            this.updating = true
            let updatedRegistration = {...this.registration}
            updatedRegistration.registeredActivities = []
            updatedRegistration.fieldBasedActivities = []
            updatedRegistration.creator = this.user
            Object.values(this.activities).forEach(activity => {
                if (activity.registered) {
                    updatedRegistration.registeredActivities.push(activity)
                }
            })
            //console.log('@@updatedRegistration', updatedRegistration)
            try {
                await http.put(`/api/registrations/${this.registration._id}`, updatedRegistration)
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error updating registration')
            }

            this.updating = false
        },
        discountHandler:function(data){
            this.hideSystemGeneratedDiscount = data;
        }
    },
    filters: {
        formatDate: (value) => moment(value).format('DD-MM-YYYY'),
        sentDate: (value) => moment(value).format('DD MMM YYYY HH:mm'),
        paymentDate: (value) => moment(value).format('DD MMM YYYY HH:mm'),
        registrationDate: (value) => moment(value).format('DD MMM YYYY HH:mm')
    }
}
</script>
<style>
.space-between-div{
    flex-wrap: wrap;
}
</style>